// extracted by mini-css-extract-plugin
module.exports = {"WhatsappButton":"styles_WhatsappButton__NuAlP","blink":"styles_blink__Ekk2x","WhatsappButtonMachinePage":"styles_WhatsappButtonMachinePage__N9F0z styles_WhatsappButton__NuAlP"};